const configDev = {
	debug_key: 'debug',
	debug: localStorage.getItem('debug') === 'true'
};

const debbuger = (text, data, type) => {
  const icons = {
    error: "💣",
    warn: "☔",
    log: "⌛",
    info: "💻",
  };
  const bg = {
    error: "#b15b00",
    warn: "#cce019",
    log: "#b15b00",
    info: "#59ab5d",
  };

  if (configDev.debug)
    console[type || "info"](
      `%c ${text} ${icons[type || "info"]}`,
      `background: ${bg[type || "info"]}; color: #ffffff; font-size: 18px`,
      data
    );
};

window.devUtils = {
	debbuger,
	config: configDev
};
